export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            有任何问题或建议？欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="bg-background-50 rounded-xl p-6 text-center hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
              <i className="ri-mail-line text-primary-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">邮件联系</h3>
            <p className="text-xs text-foreground-500">contact@91video.com</p>
          </div>

          <div className="bg-background-50 rounded-xl p-6 text-center hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
              <i className="ri-wechat-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
            <p className="text-xs text-foreground-500">91在线视频</p>
          </div>

          <div className="bg-background-50 rounded-xl p-6 text-center hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group">
            <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-secondary-200 transition-colors">
              <i className="ri-question-answer-line text-secondary-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
            <p className="text-xs text-foreground-500">在线提交反馈表单</p>
          </div>
        </div>
      </div>
    </section>
  );
}